import React, { useEffect, useState } from 'react';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import LoadingIndicator from '@wix/da-shared-react/pkg/LoadingIndicator';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import { OverlayContextProvider } from '@wix/da-react-context/pkg/OverlayContext';
import MediaManager from '@wix/da-shared-react/pkg/MediaPopup/MediaManager';
import { MediaSourceType } from '@wix/da-shared-react/pkg/MediaPopup/types';
import GallectionSimpleView from './GallectionSimpleView';
import GallectionSearchView from './GallectionSearchView';
import GallectionEmptyState from './GallectionsEmptyState';
import { GallectionType } from '../../../../types/gallection';

export interface Props {
  isSectionLoading: boolean;
  hasAnyDeviations: boolean;
  searchQuery: string;
  gallectionType: GallectionType;
  isOwner?: boolean;
}

const GallectionsSection: React.FC<Props> = ({
  isSectionLoading,
  hasAnyDeviations,
  searchQuery,
  gallectionType,
  isOwner,
}) => {
  const [isMMShown, setIsMMShown] = useState(
    isOwner &&
      typeof window !== 'undefined' &&
      window.location.search.includes('new_gallery')
  );
  const closeMM = () => setIsMMShown(false);
  // we don't do route parsing for gallery using react-router anymore
  // so make the back button simply reload the URL it returns to
  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }
    const reloadWindow = () => window.location.reload();
    window.addEventListener('popstate', reloadWindow);
    return () => {
      window.removeEventListener('popstate', reloadWindow);
    };
  }, []);

  const browsev2_mobile_thumbs_watch_button = useFlag(
    'browsev2_mobile_thumbs_watch_button'
  );

  if (isSectionLoading) {
    return <LoadingIndicator />;
  }

  if (!hasAnyDeviations) {
    return <GallectionEmptyState />;
  }

  const view = searchQuery ? (
    <GallectionSearchView />
  ) : (
    <BiLoggerContextProvider value={{ sectionname: gallectionType }}>
      <GallectionSimpleView />
      {isMMShown && (
        <MediaManager
          initialMediaSource={MediaSourceType.GALLERY}
          withMediaSourceSelector={false}
          withNewGallectionPopupOpen
          onDone={closeMM}
          onClose={closeMM}
        />
      )}
    </BiLoggerContextProvider>
  );

  return browsev2_mobile_thumbs_watch_button ? (
    <OverlayContextProvider value={{ showAuthorWatchButton: false }}>
      {view}
    </OverlayContextProvider>
  ) : (
    view
  );
};
GallectionsSection.displayName = 'GallectionsSection';

export default GallectionsSection;
